import React from "react";
import "./App.css";
import Weather from "./Weather.js";
import WeatherFooter from "./WeatherFooter.js";

function App() {
  return (
    <div className="App">
      <div className="weather">
        <div className="container">
          <div className="weather-wrapper">
            <Weather defaultCity="Gaborone" />
            <hr />
            <WeatherFooter />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
